var _rect, _path, _path2, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 12,
    fill: "#FFEECD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 69H60C63.3137 69 66 66.3137 66 63V33L54 21H30C26.6863 21 24 23.6863 24 27V63C24 66.3137 26.6863 69 30 69Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0029 21L59.6279 26.625L66.0029 33H62.0029C57.5847 33 54.0029 29.4183 54.0029 25V21Z",
    fill: "#DEBD7C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.998,
    y: 42.75,
    width: 24,
    height: 2.25,
    rx: 1.125,
    fill: "#DEBD7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.998,
    y: 36.0039,
    width: 24,
    height: 2.25,
    rx: 1.125,
    fill: "#DEBD7C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.998,
    y: 49.4941,
    width: 12,
    height: 2.25,
    rx: 1.125,
    fill: "#DEBD7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMax);
export default __webpack_public_path__ + "static/media/fileMax.664296b9.svg";
export { ForwardRef as ReactComponent };